export class InvalidCryptoError extends Error {
    constructor(additionalInfo) {
        super(`Invalid crypto! ${additionalInfo ?? ''}`.trim());
    }
}
